import CalendarIcon from "@/assets/icons/limite-calendar.svg?react";
import {
  INDISPONIVEL_AVISO,
  INDISPONIVEL_CIENCIA,
  INDISPONIVEL_INTRO,
  INDISPONIVEL_SUBTITLE,
  INDISPONIVEL_TITLE,
  PERIODO_INDISPONIVEL_LABEL,
  PERIODO_OBRA_LABEL,
} from "../equipe-obra.constants";
import { VerificacaoDialog } from "../verificacao-dialog";
import { EquipeAviso } from "../equipe-aviso";
import styles from "../verificacao-dialog/verificacao-conteudo.module.scss";
import type {
  ProfissionalIndisponivelDialogProps,
  ProfissionalIndisponivelDialogViewModel,
} from "./types-profissional-indisponivel-dialog";

/**
 * Modal "Profissional indisponível" (HU 2059/2530, Figma 12227:420433): período na obra e período
 * indisponível, de forma genérica (sem motivo nem tipo do afastamento); manter a alocação exige
 * justificativa.
 */
export function ProfissionalIndisponivelDialogView({
  linhas,
  maxJustificativa,
  onVoltar,
  onConfirmar,
}: ProfissionalIndisponivelDialogProps & ProfissionalIndisponivelDialogViewModel) {
  return (
    <VerificacaoDialog
      testId="profissional-indisponivel"
      title={INDISPONIVEL_TITLE}
      subtitle={INDISPONIVEL_SUBTITLE}
      maxLength={maxJustificativa}
      onVoltar={onVoltar}
      onConfirmar={onConfirmar}
    >
      <ul className={styles.lista}>
        {linhas.map((item) => (
          <li
            key={item.chave}
            className={`${styles.item} ${styles.itemIndisponivel}`}
            data-testid={item.testId}
          >
            <p className={styles.intro}>
              {INDISPONIVEL_INTRO.antes}
              <strong>{item.profissional}</strong>
              {INDISPONIVEL_INTRO.depois}
            </p>
            <div className={styles.cards}>
              <div className={styles.card}>
                <span className={styles.cardLabel}>
                  <CalendarIcon aria-hidden />
                  {PERIODO_OBRA_LABEL}
                </span>
                <span className={`${styles.cardValor} ${styles.cardValorLg}`}>
                  {item.periodoObra}
                </span>
              </div>
              <div className={styles.card}>
                <span className={styles.cardLabel}>
                  <CalendarIcon aria-hidden />
                  {PERIODO_INDISPONIVEL_LABEL}
                </span>
                <span
                  className={`${styles.cardValor} ${styles.cardValorLg} ${styles.cardValorPerigo}`}
                >
                  {item.periodoIndisponivel}
                </span>
              </div>
            </div>
            <EquipeAviso severity="warn" role="status">
              {INDISPONIVEL_AVISO}
            </EquipeAviso>
          </li>
        ))}
      </ul>

      <p className={`${styles.ciencia} ${styles.cienciaPequena}`}>{INDISPONIVEL_CIENCIA}</p>
    </VerificacaoDialog>
  );
}
